import React from 'react';

export type WidgetFullscreenUrlSyncContextValue = {
  fullscreenWidgetId?: string;
  setFullscreenWidgetIdInUrl: (nextWidgetId?: string) => void;
};

const noop = () => {};

export const WidgetFullscreenUrlSyncContext =
  React.createContext<WidgetFullscreenUrlSyncContextValue>({
    fullscreenWidgetId: undefined,
    setFullscreenWidgetIdInUrl: noop,
  });

export const useWidgetFullscreenUrlSync = () => {
  return React.useContext(WidgetFullscreenUrlSyncContext);
};
